import { makeElementClassNameFactory, makeRootClassName } from '@shared/utils';

const filtersElement = makeElementClassNameFactory(
  makeRootClassName('DataTableFilters')
);
const itemElement = makeElementClassNameFactory(
  makeRootClassName('DropdownMenuItem')
);

export const FILTER_GHOST_TRIGGER_CLASS_NAME =
  'flex h-6 w-6 items-center justify-center rounded-md text-dark transition-colors hover:bg-gray-100';
export const FILTER_MENU_CONTENT_CLASS_NAME = filtersElement`dropdown-menu-content`;
export const FILTER_MENU_COMPACT_CLASS_NAME = 'is-compact';
export const FILTER_ROW_CLASS_NAME = itemElement`sub-content-row`;
export const FILTER_SUB_CONTENT_CLASS_NAME = itemElement`sub-content-container`;
